import { ListItem } from '@mui/material';

import {
  EmployeeItemInfo,
  EmployeeItemInfoProps,
} from '~/components/GenericList/EmployeeItemInfo';
import { useProcessAgentInfo } from '~/components/WorkflowProposalProcess/components/ProcessAgent/useProcessAgentInfo';
import { ProposalAgent } from '~/data/proposals';

export const ProcessAgent = (
  props: Omit<EmployeeItemInfoProps, 'employeeInfo' | 'employeeId'> & {
    agent: ProposalAgent;
  },
) => {
  const { agent, ...restProps } = props;

  const { getAgentInfo } = useProcessAgentInfo();
  const agentInfo = getAgentInfo(agent);

  return (
    <ListItem {...restProps}>
      <EmployeeItemInfo employeeInfo={agentInfo} />
    </ListItem>
  );
};
